var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoalDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 15.999C5 15.999 6.50033 16.999 8.00016 16.999C9.5 16.999 11 15.999 11 15.999",
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17L8 11",
    stroke: "#0460ff",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 1.75C4.54822 1.75 1.75 4.54822 1.75 8C1.75 9.66642 2.40119 11.1791 3.46449 12.3002C4.56856 13.4643 5.75 15.0215 5.75 16.9109V18C5.75 19.2426 6.75736 20.25 8 20.25C9.24264 20.25 10.25 19.2426 10.25 18V16.9109C10.25 15.0215 11.4314 13.4643 12.5355 12.3002C13.5988 11.1791 14.25 9.66642 14.25 8C14.25 4.54822 11.4518 1.75 8 1.75ZM0.25 8C0.25 3.71979 3.71979 0.25 8 0.25C12.2802 0.25 15.75 3.71979 15.75 8C15.75 10.0656 14.9409 11.9438 13.6238 13.3325C12.5553 14.4591 11.75 15.6431 11.75 16.9109V18C11.75 20.0711 10.0711 21.75 8 21.75C5.92893 21.75 4.25 20.0711 4.25 18V16.9109C4.25 15.6431 3.44473 14.4591 2.37616 13.3325C1.0591 11.9438 0.25 10.0656 0.25 8Z",
    fill: "#282829"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalDefault);
export default __webpack_public_path__ + "static/media/goal_default.0990a55f5fba249d56e0f42059ab5f49.svg";
export { ForwardRef as ReactComponent };